export default __webpack_public_path__ + "static/media/slide4.e9ce985e.jpg";